import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/phdp-index-1.vue";
import { getRoot } from "@/api/dpIndex";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/phdp-detail"),
    meta: {
      requiresDeviceAuth: true,
    },
  },
  {
    path: "/unAuthor",
    name: "unAuthor",
    component: () => import("../views/unAuthor"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresDeviceAuth) {
    const sbxxid = to.query.sbxxid;

    if (!sbxxid) {
      next("/unAuthor");
      return;
    }

    try {
      const data = await getRoot({ sbxxid });
      if (data.code === 200 && data.data) {
        next();
      } else {
        next("/unAuthor");
      }
    } catch (error) {
      console.error("权限验证失败:", error);
      next("/unAuthor");
    }
  } else {
    next();
  }
});

export default router;
